import React, { useEffect, useState } from 'react';
import './activities.css';

import Aos from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { config } from "../../config";
import { BsArrowRight } from "react-icons/bs";
import { useLocalized } from '../../i18n/useLocalized';

const Activities = () => {
    const { t } = useTranslation();
    const loc = useLocalized();
    const navigate = useNavigate();
    const [activityData, setActivitiesData] = useState(
        JSON.parse(localStorage.getItem('activityData')) || []
    );

    useEffect(() => {
        Aos.init({
            duration: 2000,
            once: true
        });

        // Fetch activities data from the API
        const fetchActivities = async () => {
            try {
                const response = await fetch(`${config.baseUrl}/activities`);
                const data = await response.json();
                const updatedData = data.map((item) => ({
                    ...item,
                    mediaType: item.image.endsWith('.mp4') ? 'video' : 'image',
                }));

                // Always sync state; only rewrite localStorage when data changed
                setActivitiesData(updatedData);
                const storedData = JSON.parse(localStorage.getItem('activityData')) || [];
                if (JSON.stringify(updatedData) !== JSON.stringify(storedData)) {
                    localStorage.setItem('activityData', JSON.stringify(updatedData));
                }
            } catch (error) {
                console.error('Error fetching activities data:', error);
            }
        };

        fetchActivities();
    }, []);

    const MediaContent = ({ media, mediaType }) => {
        if (mediaType === 'video') {
            return (
                <video
                    muted
                    autoPlay
                    loop
                    playsInline
                    preload="auto"
                    disablePictureInPicture
                    controls={false}
                    controlsList="nodownload nofullscreen noplaybackrate"
                >
                    <source src={media} type="video/mp4" />
                </video>
            );
        } else if (mediaType === 'image') {
            return <img src={media} alt="Activity" />;
        }
        return null;
    };

    // "Lire la suite" opens the dedicated article page
    const handleReadMore = (activity) => {
        navigate(`/actualites/${activity.id}`);
    };

    return (
        <section className="info section container">
            <section className="secContainer">
                <div className="newsHead">
                    <h2 className="sketchUnderline"> {t('activities.title')} </h2>
                    <p className="newsIntro">
                        <Trans
                            i18nKey="activities.intro"
                            components={{ hl: <span style={{ color: "var(--highlight)", fontWeight: 600 }}/> }}
                        />
                    </p>
                </div>

                <div className="newsGrid">
                    {activityData.map((activity) => (
                        <article className="newsCard" data-aos="fade-up" key={activity.id}>
                            <div className="newsImg">
                                <MediaContent media={activity.image} mediaType={activity.mediaType} />
                            </div>

                            <div className="newsMetaRow">
                                <span className="metaTag">{t('activities.tag')}</span>
                                <span className="metaNum">
                                    N°{activity.id < 10 ? `0${activity.id}` : activity.id}
                                </span>
                            </div>

                            <h3 className="newsTitle">{loc(activity, 'title')}</h3>
                            <p className="twoLineText">{loc(activity, 'description')}</p>
                            <button className="readMore" onClick={() => handleReadMore(activity)}>
                                {t('activities.readMore')} <BsArrowRight/>
                            </button>
                        </article>
                    ))}
                </div>
            </section>
        </section>
    );
};

export default Activities;